import { FC } from 'react'
import { keywordContainer, hiddenKeyword, keywordText } from '../areasOfExpertise.css'
import { classNames } from '@hermes/design-system'
import { TransformedKeywordType } from '..'
import RatingBar from '../../../RatingBarForArea'

type ListItemProps = {
  keyword: TransformedKeywordType
  index: number
  sliceNumber: number
  currentRatingNumber: (number: number) => number
  currentEndorsementsNumber: (number: number) => number
  handleKeywordClick: (keyword: TransformedKeywordType) => void
}
const ListItem: FC<ListItemProps> = ({
  keyword,
  index,
  sliceNumber,
  currentRatingNumber,
  currentEndorsementsNumber,
  handleKeywordClick
}) => (
  <div
    key={keyword.name}
    className={classNames(keywordContainer, {
      [hiddenKeyword]: index > sliceNumber || (!keyword.countInReviews && !keyword.countInPeerRecommendations)
    })}
  >
    <span className={keywordText}>{keyword.name}</span>
    <RatingBar
      currentRating={currentRatingNumber(keyword.countInReviews)}
      currentEndorsement={currentEndorsementsNumber(keyword.countInPeerRecommendations)}
      onClick={() => handleKeywordClick(keyword)}
    />
  </div>
)

export default ListItem
